import { ApiBase } from '@/api/api'
import { makeGetRequest } from '@/api/fetchCalls'
import { CompletePageConditionalRuleResponse } from '@/domain/model/forms'

export type CompletePageConditionalRulesParams = {
  form?: string
  packet?: string
}
export const loadCompletePageConditionalRules = async (
  params: CompletePageConditionalRulesParams
): Promise<CompletePageConditionalRuleResponse[]> => {
  return await makeGetRequest(ApiBase + `/workflows/redirect-rules`, {
    params,
  })
}
